// Enlaces que cambian de vez en cuando. Cuando un grupo de WhatsApp se llena, se cambia aquí Y en
// netlify.toml (el enlace corto /grupo-whatsapp, que es el que se pega en Instagram y Facebook).
export const GRUPO_WHATSAPP_URL = 'https://chat.whatsapp.com/Kc3PCwHdzca6pNEgtG2vUb';
